import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { SchoolThroughUserResponse } from "@/api/catalogs/mockData/schoolThroughUserMock";

export const fetchSchoolThroughUser = (userId: number | "me") =>
  api().get<SchoolThroughUserResponse>(ApiCatalog.schoolThroughUser.endpoint, {
    urlReplacers: [{ id: userId }],
  });

const useSchoolThroughUserQuery = (
  userId: number | "me" = "me",
  options?: Omit<
    Parameters<typeof useQuery<SchoolThroughUserResponse>>[0],
    "queryKey" | "queryFn"
  >,
) => {
  return useQuery<SchoolThroughUserResponse>({
    queryKey: [ApiCatalog.schoolThroughUser.key, userId],
    queryFn: () => fetchSchoolThroughUser(userId),
    ...options,
  });
};

export default useSchoolThroughUserQuery;
